import React from 'react'
import moment from 'moment'
import TruckIcon from '@material-ui/icons/LocalShipping'
import HaulIcon from '@material-ui/icons/Repeat'
import LoadIcon from '@material-ui/icons/List'
import ProjectIcon from '@material-ui/icons/AllInbox'

const Dashboard = props => {
  return (
    <div style={{ margin: '16px' }}>
      <div>
        <span style={{ ccoclor: '#6B6C70', fontSize: '16px' }}>Active Now</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0 36px' }}>
        <span style={{ fontSize: '24px', color: '#3E3F42', fontWeight: '500' }}>Dashboard</span>
        <span style={{ fontSize: '12px', alignSelf: 'flex-end' }}>
          Last updated {moment().format('HH:mm')}
        </span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        <div
          style={{ width: '138px', height: '107px', boxShadow: '0px 1px 3px #00000029' }}
          onClick={() => props.handleChangeTab(1)}
        >
          <div
            style={{
              backgroundColor: '#F6F9FD',
              height: '35px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span style={{ fontSize: '16px', marginLeft: '16px' }}>Trucks</span>
          </div>
          <div
            style={{
              display: 'flex',
              margin: '0 16px',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '72px'
            }}
          >
            <div>
              <span style={{ fontSize: '36px' }}>{props.activeNow.drivers.length}</span>
            </div>
            <div>
              <TruckIcon
                style={{ height: '42px', width: '36px', alignSelf: 'flex-end', paddingTop: '6px' }}
              />
            </div>
          </div>
        </div>
        <div
          style={{ width: '138px', height: '107px', boxShadow: '0px 1px 3px #00000029' }}
          onClick={() => props.handleChangeTab(2)}
        >
          <div
            style={{
              backgroundColor: '#F6F9FD',
              height: '35px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span style={{ fontSize: '16px', marginLeft: '16px' }}>Hauls</span>
          </div>
          <div
            style={{
              display: 'flex',
              margin: '0 16px',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '72px'
            }}
          >
            <div>
              <span style={{ fontSize: '36px' }}>{props.activeNow.hauls.length}</span>
            </div>
            <div>
              <HaulIcon
                style={{ height: '42px', width: '36px', alignSelf: 'flex-end', paddingTop: '6px' }}
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '30px' }}>
        <div style={{ width: '138px', height: '107px', boxShadow: '0px 1px 3px #00000029' }}>
          <div
            style={{
              backgroundColor: '#F6F9FD',
              height: '35px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span style={{ fontSize: '16px', marginLeft: '16px' }}>Loads</span>
          </div>
          <div
            style={{
              display: 'flex',
              margin: '0 16px',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '72px'
            }}
          >
            <div>
              <span style={{ fontSize: '36px' }}>{props.activeNow.activeData.length}</span>
            </div>
            <div>
              <LoadIcon
                style={{ height: '42px', width: '36px', alignSelf: 'flex-end', paddingTop: '6px' }}
              />
            </div>
          </div>
        </div>
        <div
          style={{ width: '138px', height: '107px', boxShadow: '0px 1px 3px #00000029' }}
          onClick={() => props.handleChangeTab(3)}
        >
          <div
            style={{
              backgroundColor: '#F6F9FD',
              height: '35px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span style={{ fontSize: '16px', marginLeft: '16px' }}>Projects</span>
          </div>
          <div
            style={{
              display: 'flex',
              margin: '0 16px',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '72px'
            }}
          >
            <div>
              <span style={{ fontSize: '36px' }}>{props.activeNow.projects.length}</span>
            </div>
            <div>
              <ProjectIcon
                style={{ height: '42px', width: '36px', alignSelf: 'flex-end', paddingTop: '6px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
